export const DEFAULT_SCROLL_ANIMATION_TIME = 300;

export const scrollToElement = (element: Element, scrollContainer: Element, duration = DEFAULT_SCROLL_ANIMATION_TIME) => {
    const start = scrollContainer.scrollTop;
    const end = start + element.getBoundingClientRect().top;
    const startTime = performance.now();

    const scroll = () => {
        const currentTime = performance.now();
        const timeElapsed = currentTime - startTime;
        if (timeElapsed > duration) {
            scrollContainer.scrollTo(0, end);
            return;
        }

        const progress = timeElapsed / duration;
        const easedProgress = progress * (2 - progress);

        scrollContainer.scrollTo(0, start + (end - start) * easedProgress);
        requestAnimationFrame(scroll);
    }

    requestAnimationFrame(scroll);
}